/* eslint id-length: [2, {"exceptions":["a","b"]}] */

import geoSort from './sorters/geoSort';
import textSort from './sorters/textSort';
import numberSort from './sorters/numberSort';
import mixedSort from './sorters/mixedSort';
import dateSort from './sorters/dateSort';

export default function(
  a, b, header, isInverted, aBase, bBase, aIsSummary, bIsSummary) {
  // console.log({
  //   a, b, header, isInverted, aBase, bBase, aIsSummary, bIsSummary
  // });
  switch (header.type) {
    case 'geography':
      return geoSort(
        a, b, header, isInverted, aBase, bBase, aIsSummary, bIsSummary
      );
    case 'number':
    case 'percent':
    case 'currency':
      return numberSort(a, b, header, isInverted, aBase, bBase);
    case 'text':
      return textSort(
        a, b, header, isInverted, aBase, bBase, aIsSummary, bIsSummary);
    case 'date-format':
      return dateSort(a, b, header, isInverted);
    default:
      return mixedSort(a, b, header, isInverted, aBase, bBase);
  }
}



// WEBPACK FOOTER //
// ../~/eslint-loader!./js/util/sorters.js